/** App route for new-user payment onboarding (Stripe setup checkout). */
export const ONBOARDING_PATH = '/onboarding';

export function isLikelyApiPlanId(planId: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(planId);
}
